import CardsBody from './CardsBody';

const View = (props) => <CardsBody {...props} />;

export default View;
